import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.mitteilungs-vorlage-veranstaltungs-typen';
import * as api from '../../../clients/kommunikation';

@Injectable()
export class KommunikationMitteilungsVorlageVeranstaltungsTypenEffects {

    MitteilungsVorlageVeranstaltungsTypen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_MITTEILUNGS_VORLAGE_VERANSTALTUNGS_TYPEN),
        mergeMap((x: ac.GetMitteilungsVorlageVeranstaltungsTypenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getMitteilungsVorlageVeranstaltungsTypen().pipe(
                map((result: any) => {
                    return new ac.GetMitteilungsVorlageVeranstaltungsTypenErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetMitteilungsVorlageVeranstaltungsTypenFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MitteilungsVorlageQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MitteilungsVorlageQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.MitteilungsVorlageQueryService);
        }
        return this.service;
    }
}
